import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { VariationAttribute } from 'ish-core/models/product-variation/variation-attribute.model';

/**
 * Pipe
 *
 * Used on a variation attribute (of type VariationAttribute), this pipe will return the corresponding display (string) value, considering the current locale for number attribute values.
 */
@Pipe({
  name: 'ishVariationAttribute',
  pure: false,
})
export class VariationAttributePipe implements PipeTransform {
  private translateService = inject(TranslateService);

  private toDecimal(val: number): string {
    return formatNumber(val, this.translateService.currentLang);
  }

  transform(attr: VariationAttribute): string {
    if (!this.translateService.currentLang) {
      return 'undefined';
    }

    return typeof attr?.value === 'object'
      ? `${this.toDecimal(attr.value.value)}\xA0${attr.value.unit}`
      : typeof attr?.value === 'number'
      ? this.toDecimal(attr.value)
      : attr?.value || 'undefined';
  }
}
